import * as React from "react";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { Link } from "@mui/material";
import Consultas from "./Consultas";
import HomeIcon from "@mui/icons-material/Home";
import ShieldIcon from "@mui/icons-material/Shield";

export const mainListItems = (
  <React.Fragment>
    <ListItemButton>
      <ListItemIcon>
        <HomeIcon style={{ color: "white" }} />
      </ListItemIcon>

      <Link
        color="inherit"
        style={{ textDecoration: "none" }}
        href="/dashboard"
      >
        <ListItemText primary="Inicio" />
      </Link>
    </ListItemButton>

    <ListItemButton>
      <ListItemIcon>
        <ShieldIcon style={{ color: "white" }} />
      </ListItemIcon>

      <Link
        color="inherit"
        style={{ textDecoration: "none" }}
        href="/authorization"
      >
        <ListItemText primary="Autorizaciones" />
      </Link>
    </ListItemButton>

    <Consultas />
  </React.Fragment>
);
